//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('ecommerceIntegrations', {
    template: require('@legacy-components/ecommerce-integrations/ecommerce-integrations.html'),
    controller: [
      '$log',
      'EcommerceIntegrationsOptions',
      'EcommerceIntegrationsService',
      'EcommerceIntegrationsView',
      'ProductFeedHealthAcquisitionStatuses',
      'ProductFeedHealthApiService',
      'TrackingService',
      function(
                $log,
                EcommerceIntegrationsOptions,
                EcommerceIntegrationsService,
                EcommerceIntegrationsView,
                ProductFeedHealthAcquisitionStatuses,
                ProductFeedHealthApiService,
                TrackingService,
            ) {
                // TODO: Change this to be a configurable option for clients
                // Very low priority since Magento / Shopify do not support locales at the moment
                // https://curalate.atlassian.net/browse/DEV-27869
        const DEFAULT_LOCALE = 'en-US';
                /**
                 * RxJS Subjects
                 */
        this.store = {};

        this.magentoFormValues = {
          magentoStoreUrl: '',
          magentoAccessToken: '',
        };

        this.shopifyFormValues = {
          shopifyAccountName: '',
          shopifyAccessToken: '',
        };

        const completedAcquisitionStates = [
          ProductFeedHealthAcquisitionStatuses.MORE_THAN_ONE,
          ProductFeedHealthAcquisitionStatuses.SUCCESSFUL,
          ProductFeedHealthAcquisitionStatuses.FAILURE,
        ];

        const connectingAcquisitionStates = [
          ProductFeedHealthAcquisitionStatuses.EMPTY,
          ProductFeedHealthAcquisitionStatuses.PENDING,
        ];

        const trimMagentoValues = () => {
          this.magentoFormValues.magentoStoreUrl = this.magentoFormValues.magentoStoreUrl.trim();
          this.magentoFormValues.magentoAccessToken = this.magentoFormValues.magentoAccessToken.trim();
        };

        const trimShopifyValues = () => {
          this.shopifyFormValues.shopifyAccountName = this.shopifyFormValues.shopifyAccountName.trim();
          this.shopifyFormValues.shopifyAccessToken = this.shopifyFormValues.shopifyAccessToken.trim();
        };

        const logGAAction = (action) => {
          switch (this.store.clientIntegration) {
            case EcommerceIntegrationsOptions.MAGENTO:
              TrackingService.recordEvent(
                                TrackingService.CATEGORY_ECOMMERCE_INTEGRATIONS_MAGENTO,
                                action,
                            );
              break;
            case EcommerceIntegrationsOptions.SHOPIFY:
              TrackingService.recordEvent(
                                TrackingService.CATEGORY_ECOMMERCE_INTEGRATIONS_SHOPIFY,
                                action,
                            );
              break;
            default:
              $log.error('Ecommerce integrations are not properly set up.');
              break;
          }
        };

                /**
                 * Fields
                 */
        this.views = EcommerceIntegrationsView;

                // Setting to undefined so that we don't render the page until we know if their catalog is already connected
        this.isCatalogConnected = undefined;

                /**
                 * State changing functions
                 */
        this.changeViewToConfiguringForm = () => {
          EcommerceIntegrationsService.changeViewToConfiguringForm();
        };

        this.handleGetStartedClick = () => {
          logGAAction(TrackingService.ACTION_ECOMM_INTEGRATIONS_GET_STARTED_BUTTON_CLICKED);
          this.changeViewToConfiguringForm();
        };

        this.changeViewToStart = () => {
          EcommerceIntegrationsService.changeViewToStart();
        };

        this.handleQuitClick = () => {
          logGAAction(TrackingService.ACTION_ECOMM_INTEGRATIONS_QUIT_BUTTON_CLICKED);
          this.changeViewToStart();
        };

        this.handleBackButtonClick = () => {
          logGAAction(TrackingService.ACTION_ECOMM_INTEGRATIONS_GO_BACK_BUTTON_CLICKED);
          EcommerceIntegrationsService.changeViewToConfiguringForm();
        };

        this.handleFaqLinkClick = () => {
          logGAAction(TrackingService.ACTION_ECOMM_INTEGRATIONS_CATALOG_FAQ_LINK_CLICKED);
        };

        const validateCredentials = () => {
          switch (this.store.clientIntegration) {
            case EcommerceIntegrationsOptions.MAGENTO:
              trimMagentoValues();
              return EcommerceIntegrationsService.validateMagentoTokens(
                                this.magentoFormValues.magentoStoreUrl,
                                this.magentoFormValues.magentoAccessToken,
                            );
            case EcommerceIntegrationsOptions.SHOPIFY:
              trimShopifyValues();
              return EcommerceIntegrationsService.validateShopifyTokens(
                                this.shopifyFormValues.shopifyAccountName,
                                this.shopifyFormValues.shopifyApiKey,
                                this.shopifyFormValues.shopifyAccessToken,
                                this.shopifyFormValues.storefrontAccessToken,
                            );
            default:
              $log.error('Ecommerce integrations are not properly set up.');
              throw new Error('Ecommerce integrations are not properly set up');
          }
        };

        const addCatalog = () => {
          switch (this.store.clientIntegration) {
            case EcommerceIntegrationsOptions.MAGENTO:
              trimMagentoValues();
              EcommerceIntegrationsService.createMagentoCatalog(
                                this.magentoFormValues.magentoStoreUrl,
                                this.magentoFormValues.magentoAccessToken,
                                DEFAULT_LOCALE,
                            );
              break;
            case EcommerceIntegrationsOptions.SHOPIFY:
              trimShopifyValues();
              EcommerceIntegrationsService.createShopifyCatalog(
                                this.shopifyFormValues.shopifyAccountName,
                                this.shopifyFormValues.shopifyApiKey,
                                this.shopifyFormValues.shopifyAccessToken,
                                this.shopifyFormValues.storefrontAccessToken,
                                DEFAULT_LOCALE,
                            );
              break;
            default:
              $log.error('Ecommerce integrations are not properly set up.');
              break;
          }
        };

        const changeViewToConnecting = () => {
          EcommerceIntegrationsService.changeViewToConnecting();
        };

        this.addCatalogAndChangeViewToConnecting = () => {
          logGAAction(TrackingService.ACTION_ECOMM_INTEGRATIONS_SAVE_CHANGES_BUTTON_CLICKED);

          this.credentialsInvalid = false;
          changeViewToConnecting();
          validateCredentials().then((response) => {
            if (response.status === 'valid') {
              addCatalog();
            } else {
              $log.error(`Ecomm Integrations: Error validating credentials, status ${response.status}`);
              this.credentialsInvalid = response.status;
              this.changeViewToConfiguringForm();
            }
          }).catch((error) => {
            $log.error(`Ecomm Integrations: Error validating credentials, ${error}`);
            this.credentialsInvalid = true;
            this.changeViewToConfiguringForm();
          });
        };

        this.changeViewToConnectingAndPolling = (catalogId) => {
          changeViewToConnecting();
          EcommerceIntegrationsService.changeConnectingStateToPollingForAcquisitions(catalogId);
        };

        this.changeViewToConnected = () => {
          EcommerceIntegrationsService.changeViewToConnected();
        };

                /**
                 * Helpers
                 */
        const isCatalogConnectedFromResponse = function(response) {
                    // If items.size > 0, then there is a feed connected
          return response.items.length > 0;
        };

        this.$onInit = () => {
          EcommerceIntegrationsService.initialize();
          EcommerceIntegrationsService.store.subscribe((store) => {
            this.store.view = store.view;
            this.store.clientIntegration = store.integration;
          });

          ProductFeedHealthApiService.getOverviewItems().then((response) => {
            this.isCatalogConnected = isCatalogConnectedFromResponse(response);
            if (this.isCatalogConnected) {
              const catalogId = response.items[0].catalogId;
              EcommerceIntegrationsService.setCatalogId(catalogId);
              EcommerceIntegrationsService.getFirstCatalogAcquisition(catalogId)
                                .subscribe((firstAcquisitionResponse) => {
                                  if (completedAcquisitionStates.includes(firstAcquisitionResponse.acquisitionStatus)) {
                                        // If more than 1 catalog acquisition, catalog is already connected
                                    this.changeViewToConnected();
                                  } else if (connectingAcquisitionStates.includes(firstAcquisitionResponse.acquisitionStatus)) {
                                        // If just 1 catalog acquisition, then change the view to connecting
                                    this.changeViewToConnectingAndPolling(catalogId);
                                  } else {
                                    $log.error(`An unknown acquisition status was returned: ${firstAcquisitionResponse.acquisitionStatus}`);
                                  }
                                });
            }
          });
        };
      }],
  });
})();
